import { render, staticRenderFns } from "./ImportCourse.vue?vue&type=template&id=48c17652&"
import script from "./ImportCourse.vue?vue&type=script&lang=js&"
export * from "./ImportCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports